import { Vector2 } from "../../../common/vector2.js";
import { Emitter, IEmitterConfig } from "./emitter.js";

export class PayloadEmitter<T> extends Emitter
{
  private readonly _payload: T;

  public get payload(): T
  {
    return this._payload;
  }

  constructor(
    position    : Vector2,
    start_time  : number,
    payload     : T,
    duration    ?: number,
    config      ?: IEmitterConfig
  )
  {
    super( position, start_time, duration, config );
    this._payload = payload;
  }
}